import { useNavigate } from "react-router-dom";
import { FormHeader, FormSection } from "../../FormInput/FormInput";
import Styles from "../FormWrapper.module.css";
import { getDomain } from "services/Utils";
import Images from "assets/images/Images";

const GetRefNumBody = (refNum) => (
  <>
    <FormHeader>Your claim has been submitted!</FormHeader>
    <p>Thank you reporting your claim online.</p>

    {refNum && // Driver or vehicle selected is on policy (Not Other Driver)
      <p>
        Your reference number is&nbsp;
        <span className="text-primary fw-bold">{refNum}</span>. Please keep this
        for your records.
      </p>
    }
    <p>
      You can expect to hear from your dedicated CURE Claims Representative
      within 1-2 business days wtih more information regarding next steps.
    </p>
    <p>
      For more information on the claims process, visit our&nbsp;
      <a className="text-dark" href={`${getDomain()}/claims`} target="_blank">
        <u>Claims Center FAQ page</u>
      </a>
      .
    </p>
  </>
);

const GetErrorBody = (error) => (
  <>
    <FormHeader>
      {error?.header || "An error occurred while submitting your claim"}
    </FormHeader>

    {!error && (
      <p className="text-center">We apologize for the inconvience. Please log out and try again.</p>
    )}

    {error?.body}

    <div style={{display: "flex", justifyContent: "center"}}>
      <img src={Images.roundyBlueSmiling} style={{height: "10rem"}}/>
    </div>

    <hr />
    <p className="text-center text-primary fw-bold fs-5">Drive well.</p>

  </>
);

const Submit = ({ formData, refNum, error, removeLNSentence }) => {
  const navigate = useNavigate();

  let body = null;

  // No errors and claim went through successfully
  if (refNum || removeLNSentence) {
    body = GetRefNumBody(refNum)
  }
  else {
    // "Duplicate" claim with the same loss date
    if (error) {
      body = GetErrorBody(error)
    }
    // Error not related to "Duplicate" claim
    else {
      body = GetErrorBody();
    }
  }

  return (
    <div
      className={`${Styles.container} ${Styles.formContainer} ${Styles.fieldContainer}`}
    >
      <FormSection setPadding={false}>
        {body}

        <div className="d-flex justify-content-center mt-5">
          <button
            className="btn btn-primary-grad btn-sm m-1"
            onClick={() => navigate("/home")}
          >
            Return to My Account Home
          </button>
        </div>
      </FormSection>
    </div>
  );
};

export default Submit;
